import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {BlogsHttpService} from '../../../../services/http-services/blogs/blogs-http.service';
import {GrBlog} from '../../../../interfaces/blogs-interfaces';
import {BlogTypeEnum} from '../../../../enums/blog-enums';
import {ActivatedRoute, Router} from '@angular/router';
import {GrPagination} from '../../../../interfaces/general-interfaces';

@Component({
  selector: 'app-admin-blogs',
  templateUrl: './admin-blogs.component.html'
})
export class AdminBlogsComponent implements OnInit {
  blogs: GrBlog[] = [];
  blogsPagination!: GrPagination;
  blogForDelete: number | null = null;
  urlParams: {page: number, blogType: string} = {
    page: 1,
    blogType: BlogTypeEnum.active
  };
  protected readonly BlogTypeEnum = BlogTypeEnum;

  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private blogsHttpService: BlogsHttpService) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((res: any) => {
      this.urlParams.blogType = history.state.blogType;
      this.getBlogs();
    });
  }

  getBlogs(): void {
    this.urlParams.page = (this.blogsPagination?.currentPage) ? this.blogsPagination.currentPage : 1;
    this.blogsHttpService.getBlogs(this.urlParams).then(res => {
      this.blogs = res.data;
    });
  }

  removeBlog(): void {
    this.blogsHttpService.deleteBlog({blogId: this.blogForDelete}).then(() => {
      const blogIndex = this.blogs.findIndex((blog) => blog.id === this.blogForDelete);
      this.blogs.splice(blogIndex, 1);
      this.blogForDelete = null;
    });
  }

  createBlog(): void {
    this.blogsHttpService.postBlog().then(res => {
      this.router.navigate([PAGES_AND_PATHS.adminEditBlog.pagePath, res.data.id]);
    });
  }

  onChangeActiveTab(activeTab: string): void {
    this.urlParams.blogType = activeTab;
    this.getBlogs();
  }
}
